import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";

import FileUpload from "../../../../utility/fileUpload/fileUpload";
import defaultWATemplateImg from "../../../../../assets/images/messageFormats/defaultWATemplateImage.png";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from "../../../../../utils/constants";
import { greyColor, whiteColor } from "../../../../../utils/colors";
import { ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL, isTemplateCreated } from "../../constant";
import TouchTooltip from "../../utils/TouchTooltip";
import { getVendorField } from "../../../../../utils/whiteLabelling";
import { UserContext, UserContextPayload } from "../../../../../context/userContext";

const CarouselTemplateCardHeaderPreview = (props: any) => {
    
    const { 
        cardData, cardIndex, carouselFiles, editable = false, uploadFileHandlerCarousel, removeFileHandlerCarousel, isFileUploaded 
    } = props;

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const { vendorData } = useContext(UserContext) as UserContextPayload;

    const [hover, setHover] = useState(false);
    const [editingMedia, setEditingMedia] = useState(false);

    // Constants
    const isEditable = editable && !isTemplateCreated(createTemplatePayload);

    const headerType = cardData?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() ?? "";
    const isMediaHeader = ALLOWED_MEDIA_HEADER_TYPES_CAROUSEL?.includes(headerType);

    const headerData = cardData?.whatsapp_template_header?.whatsapp_template_header_data?.[0];
    const content = headerData?.whatsapp_template_header_data_value;
    
    const googleStorageId = headerData?.whatsapp_template_header_data_google_storage_id;
    const imageSrc = googleStorageId
        ? `${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/storage/file?file_id=${googleStorageId}&flag_info=false`
        : content?.startsWith("http") ? content : null;

    const hasMedia = !!(imageSrc || content);
    const mediaUrl = imageSrc || content;
    const isDisabled = isTemplateCreated(createTemplatePayload);
    const cardFiles = carouselFiles?.find((f: any) => f.index === cardIndex)?.carousels ?? [];
    const hasUploadedMedia = Boolean(googleStorageId) || cardFiles?.length > 0;
    const label = headerType?.charAt(0)?.toUpperCase() + headerType?.slice(1) || "";

    useEffect(() => {
        if (!editable) {
            setEditingMedia(false);
        }
    }, [editable]);

    if (!isMediaHeader) {
        return null;
    }

    // Functions
    const renderMediaHeaderContent = (isEditable: boolean) => (
        <>
            {isEditable && hasUploadedMedia && !isDisabled && removeFileHandlerCarousel && (
                <TouchTooltip title="Remove media" >
                    <DeleteOutlineIcon
                        className={styles.whatsappPreview__cardMediaDeleteIcon}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (googleStorageId) {
                                removeFileHandlerCarousel(googleStorageId, cardIndex);
                            }
                        }}
                    />
                </TouchTooltip>
            )}

            {headerType === "image" && hasMedia ? (
                    <Box className={`${styles.whatsappPreview__mediaHeader} ${styles["whatsappPreview__mediaHeader--previewImage"]}`}>
                        <div className={styles.whatsappPreview__mediaHeader__previewInner}>
                            <img alt="Header" src={mediaUrl || defaultWATemplateImg} />
                        </div>
                    </Box>
                ) : headerType === "image" ? (
                    <Box className={`${styles.whatsappPreview__mediaHeader} ${styles[`whatsappPreview__mediaHeader--${headerType}`]} ${styles.whatsappPreview__textInputError}`}>
                        <Typography variant="caption" onClick={isEditable ? () => setEditingMedia(true) : undefined} sx={isEditable ? { cursor: "pointer" } : undefined}>
                            {label}
                        </Typography>
                    </Box>
                ) : null
            }

            {headerType === "video" && hasMedia ? (
                    <Box className={`${styles.whatsappPreview__mediaHeader} ${styles["whatsappPreview__mediaHeader--previewVideo"]}`}>
                        <div className={styles.whatsappPreview__mediaHeader__previewInner}>
                            <video key={mediaUrl} controls className="video-tag">
                                <source src={mediaUrl || ""} type="video/mp4" />
                            </video>
                        </div>
                    </Box>
                ) : headerType === "video" ? (
                    <Box className={`${styles.whatsappPreview__mediaHeader} ${styles[`whatsappPreview__mediaHeader--${headerType}`]} ${styles.whatsappPreview__textInputError}`}>
                        <Typography variant="caption" onClick={isEditable ? () => setEditingMedia(true) : undefined} sx={isEditable ? { cursor: "pointer" } : undefined}>
                            {label}
                        </Typography>
                    </Box>
                ) : null
            }
        </>
    );

    return isEditable ? (
        <Box 
            className={`${styles.whatsappPreview__cardMediaDeleteWrap} ${hasMedia ? "" : `${styles.whatsappPreview__mediaHeader} ${styles[`whatsappPreview__mediaHeader--${headerType}`]}`}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {!hasMedia && (editingMedia || hover) && uploadFileHandlerCarousel && removeFileHandlerCarousel ? (
                <Box className={styles.whatsappPreview__mediaHeader__upload}>
                    <FileUpload
                        uploadedFileDetails={cardFiles}
                        multipleFileAllow={false}
                        fileSizeAllowed={getWhatsappMediaSizeLimit(headerType)}
                        fileTypeAllowed={getWhatsappMediaAllowedFileTypes(headerType)?.allowedType}
                        fileNumberAllowed={1}
                        isDisabled={isDisabled}
                        uploadFileHandler={(e) => uploadFileHandlerCarousel(e, cardIndex)}
                        removeFileHandler={(storageId: number) => removeFileHandlerCarousel(storageId, cardIndex)}
                        isDeleteFileIconVisible={isFileUploaded}
                        bgColor={whiteColor}
                        flagWhatsapp={true}
                        flagShowJustIcon
                        flagShowJustIconBgColor={greyColor}
                    />
                </Box>
            ) : (
                renderMediaHeaderContent(true)
            )}
        </Box>
    ) : (
        renderMediaHeaderContent(false)
    );
};

export default CarouselTemplateCardHeaderPreview;